import React from 'react';
import PropTypes from 'prop-types';
import { ActionIconArrowLeft, Link } from '@klarna/bubble-ui';
import { Flex } from '@klarna/mp-ui';
import { Message } from 'mage-i18n';

const BackLink = ({ onClick, tKey = 'products-fe.components.global_prices_dialog' }) => {
  return (
    <Link
      onPress={e => {
        e.preventDefault();
        onClick();
      }}
      textToken="text-style/text/labels/body/medium"
    >
      <Flex style={{ flexDirection: 'row', cursor: 'pointer' }} onClick={onClick}>
        <Flex style={{ marginTop: 2 }}>
          <ActionIconArrowLeft colorToken="colors/text/accent" />
        </Flex>
        <Message path={`${tKey}.buttons.back`} />
      </Flex>
    </Link>
  );
};

BackLink.propTypes = {
  onClick: PropTypes.func.isRequired,
  tKey: PropTypes.string,
};

export default BackLink;
